var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1804 13.5902C22.5284 14.2421 21.4715 14.2421 20.8196 13.5902L12.1805 4.95108L3.54146 13.5902C2.88955 14.2421 1.83261 14.2421 1.1807 13.5902C0.528796 12.9382 0.528796 11.8813 1.1807 11.2294L11.0001 1.40995C11.6521 0.758044 12.709 0.758045 13.3609 1.40995L23.1804 11.2294C23.8323 11.8813 23.8323 12.9382 23.1804 13.5902Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.4d0e0d582ac4fc661dffa83d70b01411.svg";
export { ForwardRef as ReactComponent };